import React, { useState } from "react";
import emailjs from "emailjs-com";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fname: "",
    cnumber: "",
    email: "",
    msg: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
       "service_0g2aw13", 
        "template_mogqr2k",
        formData,
        "H0PQJHpMmjedwbKk8"
      )
      .then((response) => {
        alert("Message sent successfully!");
        setFormData({ fname: "", cnumber: "", email: "", msg: "" }); 
      })
      .catch((error) => {
        alert("Error sending message, try again later.");
        console.error(error);
      });
  };

  return (
    <div id="contactUs">
      <div className="flex items-center justify-center font-bold md:text-[20px] text-[18px] text-center w-full bg-yellow-200 text-slate-700 p-8">
        <p>
          How can we help you? <br />
          Send us a Message...
        </p>
      </div>
      <div className="p-4 py-8">
        <div className="flex flex-col lg:flex-row lg:justify-center lg:items-start gap-8">
          <div className="flex justify-center lg:w-1/2">
            <img
              src="./assets/Images/helper.gif"
              className="h-60 sm:h-72 lg:h-80 object-contain"
              alt="Helper"
            />
          </div>

          <div className="w-full lg:w-1/2 lg:mr-10">
            <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto">
              
              <div className="flex flex-col sm:flex-row gap-4">
                <input
                  type="text"
                  name="fname"
                  value={formData.fname}
                  onChange={handleChange}
                  className="flex-1 bg-slate-100 border border-slate-700 rounded-lg focus:border-slate-500 p-2"
                  placeholder="Full Name"
                  required
                />
                <input
                  type="text"
                  name="cnumber"
                  value={formData.cnumber}
                  onChange={handleChange}
                  className="flex-1 bg-slate-100 border border-slate-700 rounded-lg focus:border-slate-500 p-2"
                  placeholder="Contact Number"
                  required
                />
              </div>


              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="mt-5 w-full bg-slate-100 border border-slate-700 rounded-lg focus:border-slate-500 p-2"
                placeholder="Email"
                required
              />


              <textarea
                name="msg"
                value={formData.msg}
                onChange={handleChange}
                className="mt-5 w-full bg-slate-100 border border-slate-700 rounded-lg focus:border-slate-500 p-2 h-40"
                placeholder="Type your message"
                required
              ></textarea>


              <div className="flex justify-start mt-5">
                <button
                  type="submit"
                  className="text-white bg-blue-950 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
